import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,

} from '@angular/core';
import {ExtensionHelper} from '@shared/helpers/extension-helper.service';
import {AddSourceDialogForm} from '@feature/sources/add-source-dialog/add-source-dialog.form';
import {SelectedFileInterface} from '../interface/select-file.interface';
import {
    AddAttachmentDialogForm,
} from '@shared/modules/content/modules/components/attachment/add-attachment-dialog/add-attachment-dialog.form';

type SourceFormType = AddSourceDialogForm | AddAttachmentDialogForm;

@Component({
    selector: 'app-add-source',
    templateUrl: './add-source.component.html',
    styleUrls: ['./add-source.component.scss'],
})
export class AddSourceComponent {
    @Input()
    disabled: boolean = false;

    @Input()
    isLoading: boolean = false;

    @Output()
    sourceFormChange: EventEmitter<SourceFormType> = new EventEmitter<SourceFormType>();

    @Input()
    sourceForm!: SourceFormType;

    @ViewChild('file', {static: false})
    file!: ElementRef;

    @ViewChild('linkTextarea', {static: false}) linkTextarea!: ElementRef;

    selectedFile?: SelectedFileInterface;

    #extensionHelper: ExtensionHelper;

    constructor(
        extensionHelper: ExtensionHelper,
    ) {
        this.#extensionHelper = extensionHelper;
    }

    addAttachment(): void {
        document.getElementById('attachment-file')!.click();
    }

    onFileChange(): void {
        const file: File = this.file.nativeElement.files[0];
        const extension: string = file.name.split('.').pop() ?? 'file';

        this.disabled = true

        this.selectedFile = {file, name: file.name, extension, type: this.#extensionHelper.resolve(extension)};
        this.sourceForm.setFile(file);
        this.sourceFormChange.emit(this.sourceForm);
    }

    onUrlChange(): void {
        const url = this.getLinkTextareaValue();

        this.sourceForm.setLink(url);
        this.sourceFormChange.emit(this.sourceForm);
    }

    getLinkTextareaValue(): string {
        return this.linkTextarea.nativeElement.value;
    }
}
